/* Shopify-hosted media only. Delegated once; every lookup is instance-scoped. */
(function () {
  "use strict";
  if (window.__tocaProductMediaInitialized) return;
  window.__tocaProductMediaInitialized = true;

  const panels = (gallery) => Array.from(gallery.querySelectorAll("[data-product-media-panel]"));
  // Selectors live in the product info column, outside the gallery; both are scoped by section.
  const sectionOf = (el) => el.closest("[data-product-section]");
  const galleryFor = (el) => sectionOf(el)?.querySelector("[data-product-gallery]");
  const selectors = (gallery) => Array.from((sectionOf(gallery) || gallery).querySelectorAll("[data-product-media-select]"));
  const pauseVideos = (root) => root.querySelectorAll("video").forEach((video) => video.pause());

  const mobileSwipe = window.matchMedia("(max-width: 900px) and (pointer: coarse)");
  let swipe = null;

  function playSelectedVideo(panel) {
    const video = panel.querySelector("video");
    if (!video || document.hidden) return;
    // Muted playback works for touch/variant selection too; native controls can enable audio.
    video.muted = true;
    try {
      Promise.resolve(video.play()).then(() => {
        if (panel.hidden || !panel.isConnected || document.hidden) video.pause();
      }).catch(() => { /* Autoplay may be denied; leave native controls usable. */ });
    } catch (_) { /* Older browsers may throw synchronously. */ }
  }

  function activatePanel(gallery, active, autoplay = false) {
    if (!active) return;
    panels(gallery).forEach((panel) => {
      if (panel !== active) pauseVideos(panel);
      panel.hidden = panel !== active;
    });
    selectors(gallery).forEach((button) => {
      button.setAttribute("aria-pressed", String(button.dataset.productMediaSelect === active.dataset.mediaId));
    });
    if (autoplay && active.dataset.mediaType === "video") playSelectedVideo(active);
  }

  function activateMedia(gallery, mediaId, imageId) {
    const items = panels(gallery);
    const active = items.find((panel) => mediaId != null && panel.dataset.mediaId === String(mediaId)) ||
      items.find((panel) => imageId != null && panel.dataset.mediaType === "image" && panel.dataset.imageId === String(imageId));
    activatePanel(gallery, active, true);
  }

  function initMedia(root) {
    root.querySelectorAll("[data-product-gallery]").forEach((gallery) => {
      const items = panels(gallery);
      activatePanel(gallery, items.find((panel) => !panel.hidden) || items[0]);
    });
  }

  document.addEventListener("click", (event) => {
    const button = event.target.closest("[data-product-media-select]");
    if (!button) return;
    const gallery = galleryFor(button);
    if (gallery) activateMedia(gallery, button.dataset.productMediaSelect);
  });

  // Enter/Space use native button activation; arrows/Home/End add convenient navigation.
  document.addEventListener("keydown", (event) => {
    const button = event.target.closest("[data-product-media-select]");
    if (!button || !["ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown", "Home", "End"].includes(event.key)) return;
    const gallery = galleryFor(button);
    if (!gallery) return;
    const buttons = selectors(gallery);
    const current = buttons.indexOf(button);
    let next;
    if (event.key === "Home") next = 0;
    else if (event.key === "End") next = buttons.length - 1;
    else next = (current + (["ArrowLeft", "ArrowUp"].includes(event.key) ? -1 : 1) + buttons.length) % buttons.length;
    event.preventDefault();
    buttons[next].focus();
    activateMedia(gallery, buttons[next].dataset.productMediaSelect);
  });

  // Horizontal touch swipes only on mobile. Vertical scroll and pinch zoom stay native.
  document.addEventListener("pointerdown", (event) => {
    if (event.pointerType !== "touch") return;
    swipe = null;
    if (!event.isPrimary || !mobileSwipe.matches) return;
    const gallery = event.target.closest("[data-product-gallery]");
    const panel = event.target.closest("[data-product-media-panel]");
    if (!gallery || !panel || panel.hidden || panels(gallery).length < 2 ||
        event.target.closest("button, a, input, select, textarea, [contenteditable]")) return;
    // Do not steal scrubbing, volume or fullscreen gestures from native video controls.
    const video = event.target.closest("video");
    if (video && video.controls && event.clientY >= video.getBoundingClientRect().bottom - 56) return;
    swipe = { gallery, panel, pointerId: event.pointerId, x: event.clientX, y: event.clientY };
  }, { passive: true });

  document.addEventListener("pointercancel", () => { swipe = null; }, { passive: true });
  document.addEventListener("pointerup", (event) => {
    if (!swipe || event.pointerId !== swipe.pointerId) return;
    const gesture = swipe;
    swipe = null;
    if (!mobileSwipe.matches || !gesture.gallery.isConnected || gesture.panel.hidden) return;
    const dx = event.clientX - gesture.x;
    const dy = event.clientY - gesture.y;
    if (Math.abs(dx) < 48 || Math.abs(dx) <= Math.abs(dy) * 1.5) return;
    const items = panels(gesture.gallery);
    const index = items.indexOf(gesture.panel);
    const next = (index + (dx < 0 ? 1 : -1) + items.length) % items.length;
    activatePanel(gesture.gallery, items[next], true);
  }, { passive: true });

  document.addEventListener("product:variant-media", (event) => {
    const section = event.target.closest("[data-product-section]");
    const gallery = section && section.querySelector("[data-product-gallery]");
    if (gallery && event.detail) activateMedia(gallery, event.detail.mediaId, event.detail.imageId);
  });

  // Also stop any delayed play event from a panel that has already been hidden.
  document.addEventListener("play", (event) => {
    const panel = event.target.closest("[data-product-media-panel]");
    if (panel && (panel.hidden || !panel.isConnected || document.hidden) && event.target.tagName === "VIDEO") event.target.pause();
  }, true);

  document.addEventListener("shopify:section:load", (event) => initMedia(event.target));
  document.addEventListener("shopify:section:unload", (event) => {
    if (swipe && event.target.contains(swipe.gallery)) swipe = null;
    event.target.querySelectorAll("[data-product-gallery], [data-hero-section]").forEach(pauseVideos);
  });
  document.addEventListener("visibilitychange", () => {
    if (document.hidden) {
      swipe = null;
      document.querySelectorAll("[data-product-gallery], [data-hero-section]").forEach(pauseVideos);
    }
  });

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", () => initMedia(document), { once: true });
  else initMedia(document);
})();
